// Copyright 2024, Imprivata, Inc.  All rights reserved.

import { EventProvider } from '@imprivata-cloud/core';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type React from 'react';

import { IcpCoreFlow } from './containers/icp-core';
import { TenantLogin } from './containers/tenant-lookup';
import { Notifications } from './errorHandler/context/Notifications';
import ErrorBoundary from './errorHandler/ErrorBoundary';
import { ErrorView } from './errorHandler/ErrorView';
import { LocaleProvider } from './i18n/localeProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

export const App: React.FC = () => {
  const isTenantLookup = globalThis.location.pathname.includes('tenant-lookup');

  if (isTenantLookup) {
    return (
      <LocaleProvider>
        <ErrorBoundary fallback={<ErrorView />}>
          <QueryClientProvider client={queryClient}>
            <EventProvider>
              <Notifications
                key={'tenant-lookup'}
                translationRoot={'tenant-lookup'}
                renderBanner={false}
              >
                <TenantLogin />
              </Notifications>
            </EventProvider>
          </QueryClientProvider>
        </ErrorBoundary>
      </LocaleProvider>
    );
  }

  return (
    <div className="authn-container">
      <LocaleProvider>
        <QueryClientProvider client={queryClient}>
          <EventProvider>
            <IcpCoreFlow />
          </EventProvider>
        </QueryClientProvider>
      </LocaleProvider>
    </div>
  );
};
